// src/features/dashboard/services/tableTeamApi.ts

import api from '../../../api/apiService';
import { ENDPOINTS } from '../../../api/endpoints';

export type TeamTablePayload = {
  managerEmployeeCode: string;
  fromDate: string;
  toDate: string;
  teamLeadEmployeeCode: string | null;
  geo: string | null;
  searchText: string | null;
};

export type DashboardGridEmployee = {
  employeeCode: string;
  employeeName: string;
  designation: string;
  geo: string;
  loggedDate: string;
  displayValue: string;
  totalMinutes: number;
  avgMinutesPerDay: number;
};

export type TeamAverage = {
  loggedDate: string;
  teamAverageDisplay: string;
};

export type DashboardGridResponse = {
  employees: DashboardGridEmployee[];
  teamAverages: TeamAverage[];
};

export const getTeamTableData = async (
  payload: TeamTablePayload,
): Promise<DashboardGridResponse> => {
  const token =
    sessionStorage.getItem('token') ||
    localStorage.getItem('token');

  const response = await api.post<DashboardGridResponse>(
    ENDPOINTS.TEAM_TABLE,
    payload,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    },
  );

  console.log('TEAM_TABLE PAYLOAD:', payload);
  console.log('TEAM_TABLE RESPONSE:', response.data);
  console.log('TEAM_TABLE EMPLOYEES:', response.data?.employees);
  console.log('TEAM_TABLE TEAM AVERAGES:', response.data?.teamAverages);

  return response.data;
};
